import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import { Motion, spring } from 'react-motion';

import { FormattedMessage } from 'react-intl';

import { Table, TableBody, TableRow, TableHeader, TableHeaderColumn } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import moment from 'moment';
import PanelTableRow from './PanelTableRow';
import { DATE, NUMBER } from '../../constants/DataTypes';

const styles = {
  middle: {
    verticalAlign: 'middle',
  },
  sortIcon: {
    color: '#9e9e9e',
    fontSize: 18,
  },
  sortButton: {
    padding: 8,
    paddingLeft: 4,
    width: 'auto',
    height: 'auto',
  },
  tableColumn: {
    whiteSpace: 'normal',
    width: 120,
  },
  emptyText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 32,
    paddingBottom: 32,
    color: '#b3b3b3',
    fontSize: 16,
  },
};

class PanelTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dataSource: props.dataSource,
      descending: true,
      orderBy: '',
    };
    this.sort = this.sort.bind(this);
  }

  componentDidMount() {
    const { dataSource, initSort } = this.props;
    if (dataSource && dataSource.length && initSort) {
      this.sort(null, this.props.initSort);
    }
  }

  /* Sort the table by one of the row fields */
  sort(event, fieldKey) {
    const { dataSource, descending } = this.state;
    const { type } = dataSource[0][fieldKey];

    let sortedDataSource;

    switch (type) {
      case DATE:
        sortedDataSource = sortBy(dataSource, o => moment(o[fieldKey].value, 'DD.MM.YYYY').format('X'));
        break;
      case NUMBER:
        sortedDataSource = sortBy(dataSource, o => o[fieldKey].value);
        break;
      default:
        sortedDataSource = dataSource.sort((a, b) => a[fieldKey].value.localeCompare(b[fieldKey].value, 'is'));
    }

    const newState = {
      dataSource: descending ? sortedDataSource : reverse(sortedDataSource),
      descending: !descending,
      orderBy: fieldKey,
    };

    this.setState(newState);
  }

  render() {
    const { dataSource, descending, orderBy } = this.state;
    const { actions, emptyText } = this.props;
    return dataSource && dataSource[0] ?
      <Table
        bodyStyle={{ overflowX: 'none', overflowY: 'none' }}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
        >
          <TableRow>
            {dataSource[0].fields.map(f => (
              <TableHeaderColumn key={f} style={{ ...styles.tableColumn, ...dataSource[0][f].style }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {dataSource[0][f].label}
                  <Motion style={{ x: spring(descending && f === orderBy ? 0 : 180) }}>
                    {({ x }) => (
                      <IconButton
                        iconClassName="material-icons"
                        onClick={e => this.sort(e, f)}
                        iconStyle={{
                          ...styles.sortIcon,
                          transform: `rotate3d(1, 0, 0, ${x}deg)`,
                          WebkitTransform: `rotate3d(1, 0, 0, ${x}deg)`,
                        }}
                        style={{ ...styles.sortButton, ...styles.middle }}
                      >
                        sort
                      </IconButton>
                      )
                    }
                  </Motion>
                </span>
              </TableHeaderColumn>
              ))}
            {actions && <TableHeaderColumn style={styles.tableColumn} ><span><FormattedMessage id="panel.actions" /></span></TableHeaderColumn>}
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
        >
          {(!dataSource || !dataSource.length) && <span>Empty</span>}
          {dataSource.map((d, i) =>
            <PanelTableRow item={d} key={i} columnStyle={styles.tableColumn} actions />)}
        </TableBody>
      </Table> : <div style={styles.emptyText}><FormattedMessage id={emptyText} /></div>;
  }
}

PanelTable.propTypes = {
  dataSource: PropTypes.array,
  emptyText: PropTypes.string,
  actions: PropTypes.bool,
  initSort: PropTypes.string,
};

PanelTable.defaultProps = {
  actions: false,
  emptyText: 'panel.empty',
};

export default PanelTable;



// WEBPACK FOOTER //
// ./src/components/panels/PanelTable.js